<ion-router-outlet
  [environmentInjector]="environmentInjector"
></ion-router-outlet>
<ion-progress-bar
  *ngIf="loaderService.isVisible$ | async"
  type="indeterminate"
></ion-progress-bar>
<pwa-install manifest-url="./manifest.webmanifest"></pwa-install>
<hexa-update></hexa-update>
